import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { CustomSVGProps, getBaseSVGProps } from './utils';

const VaccinationsFilled: React.FC<CustomSVGProps> = (props) => {
    return (
        <Svg {...getBaseSVGProps(props, 16)} fill="none">
            <Path
                d="M14.3725 3.21272L12.7821 1.62233C12.6135 1.45377 12.3402 1.45377 12.1717 1.62233C12.0031 1.79089 12.0031 2.06417 12.1717 2.23273L12.3388 2.3998L11.4933 3.24529L11.0464 2.79842C10.8778 2.62986 10.6046 2.62986 10.436 2.79842C10.2674 2.96697 10.2674 3.24026 10.436 3.40882L10.5873 3.56016L9.7505 4.397L10.5665 5.21303L9.85942 5.92014L9.0434 5.10411L8.22096 5.92654L9.03699 6.74257L8.32988 7.44968L7.51385 6.63365L6.69142 7.45609L7.50745 8.27211L6.80034 8.97922L5.98431 8.16319L4.80796 9.33954L5.10349 9.63508L4.31368 10.4249L4.63462 10.7458L1.6263 13.7541C1.45603 13.9244 1.45603 14.2005 1.6263 14.3708C1.79657 14.541 2.07264 14.541 2.24291 14.3708L5.25123 11.3624L5.57039 11.6816L6.3602 10.8918L6.65725 11.1888L12.4366 5.40945L12.5906 5.56344C12.7592 5.732 13.0325 5.732 13.201 5.56344C13.3696 5.39489 13.3696 5.1216 13.201 4.95304L12.75 4.502L13.5955 3.65651L13.7621 3.82312C13.9306 3.99168 14.2039 3.99168 14.3725 3.82312C14.541 3.65456 14.541 3.38128 14.3725 3.21272Z"
                fill={props.color}
            />
        </Svg>
    );
};

export default React.memo(VaccinationsFilled);
